import React, {Component} from 'react';
import { Link } from 'react-router';
import { Col, Row } from 'reactstrap';
import { Button, Menu, MenuItem } from '@material-ui/core';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { imgStoragePath } from '../../../../constants';
export default class LogAddEnquiry extends Component{
    constructor(){
        super();
        this.state = {
          exportMenuAnchor: null
        };
    }
    render(){
        return(
            <Row>
                <Col md="5">
                <h1 className="block-title">Logs</h1>
                <p className="block-subs">Contains logs of previous Finance Reports that were created by the user</p>
                </Col>
                <Col md="3">
                <div className="download-links" style={{position:"relative",top:"-11px"}}>
                <span style={{float:'right',marginTop:'20px'}}>
                <a href="https://itunes.apple.com/za/app/empower/id1209983674" target="_blank" style={{display:'inline',padding:'0px',border:'none'}} >
                <img src={imgStoragePath+'phase-2/app-store-apple.png'}  width="100px" style={{width:'110px'}} alt="maintenance image" /> </a>
                <a href="https://play.google.com/store/apps/details?id=com.emis.acumen"  target="_blank" style={{display:'inline',padding:'0px',border:'none'}}>
                <img src={imgStoragePath+'phase-2/google-play-badge.png'} width="100px" style={{width:'125px'}} alt="maintenance image" /> </a>
                </span>
                <p style={{fontSize:'13px',fontWeight:'300',float:"right", position:"relative", left:"-95px", top:"-65px"}}>Access EMPower App on</p>
                </div>
                </Col>
                <Col md="4">
                <div className="add-enquiry-block -block" style={{position:"relative", top:"40px"}}>
                    <Button
                        size='small'
                        variant='outlined'
                        color='primary'
                        onClick={(e) => this.setState({ exportMenuAnchor: e.currentTarget })}
                        endIcon={<ArrowDropDownIcon style={{ fontSize: '1.15rem' }} />}
                    >
                        <SaveAltIcon style={{ fontSize: '1.15rem' }} />Export
                    </Button>
                    <Menu
                        anchorEl={this.state.exportMenuAnchor}
                        open={Boolean(this.state.exportMenuAnchor)}
                        onClose={() => this.setState({ exportMenuAnchor: null })}
                        getContentAnchorEl={null}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        transitionDuration={0}
                    >
                        <MenuItem onClick={() => { this.props.downLoadLogListing('pdf'); this.setState({ exportMenuAnchor: null }); }}>
                            <img src={imgStoragePath+"pdf_icon.png"} alt="img" style={{ marginRight: '8px', width: '16px' }} />PDF
                        </MenuItem>
                        <MenuItem onClick={() => { this.props.downLoadLogListing('xls'); this.setState({ exportMenuAnchor: null }); }}>
                            <img src={imgStoragePath+"excel_icon.png"} alt="img" style={{ marginRight: '8px', width: '16px' }} />Excel
                        </MenuItem>
                    </Menu>
                    <Link className="primary-btn" to="/mr-calculator">+ New Finance Report</Link>
                </div>
                </Col>
            </Row>

        )
    }
}
